import { AREA_CODE_LIST, AREA_CODE_NAME_FALLBACK } from "@/constants/areaCodes";
import VueI18n, { TranslateResult } from "vue-i18n";

export interface AreaCodePickerOption {
  text: string;
  value: string;
  id: number;
}

type AreaCodeI18n = Pick<VueI18n, "locale" | "t" | "te">;

function toI18nText(value: TranslateResult): string {
  return typeof value === "string" ? value : String(value);
}

/** 获取地区名称（优先 i18n，否则繁体兜底） */
export function getAreaCodeName(i18n: AreaCodeI18n, id: number): string {
  const key = `areaCodes.${id}`;
  if (i18n.te ? i18n.te(key) : toI18nText(i18n.t(key)) !== key) {
    return toI18nText(i18n.t(key));
  }
  return AREA_CODE_NAME_FALLBACK[id] || String(id);
}

/** 构建 Picker 选项列表（随 locale 切换更新） */
export function buildAreaCodePickerOptions(i18n: AreaCodeI18n): AreaCodePickerOption[] {
  return AREA_CODE_LIST.map(item => ({
    text: `${getAreaCodeName(i18n, item.id)} +${item.area_code}`,
    value: item.area_code,
    id: item.id
  }));
}

/** 按区号查找条目 */
export function findAreaCodeByCode(areaCode: string | number, defaultCode = "852") {
  return (
    AREA_CODE_LIST.find(item => String(item.area_code) === String(areaCode)) ||
    AREA_CODE_LIST.find(item => String(item.area_code) === defaultCode)
  );
}

/** 初始化默认区号（默认 852 香港） */
export function initDefaultAreaCode(
  form: { zone_code: string | number; area_code_id: number | string },
  defaultCode = "852"
) {
  const item = findAreaCodeByCode(form.zone_code || defaultCode, defaultCode);
  if (!item) {
    return null;
  }
  form.zone_code = item.area_code;
  form.area_code_id = item.id;
  return item;
}

/** 获取 Picker 默认选中索引 */
export function getAreaCodePickerIndex(
  options: AreaCodePickerOption[],
  areaCodeId: number | string
) {
  const index = options.findIndex(item => item.id === areaCodeId);
  return index >= 0 ? index : 0;
}
